// extracted by mini-css-extract-plugin
export default {"container":"SparePartsFinder-vOSmE__container","header":"SparePartsFinder-T4piX__header","searchinput":"SparePartsFinder-3kg5b__searchinput","link":"SparePartsFinder-nd6do__link"};